import React from 'react';

export const LazyDatePicker = React.lazy(() =>
  import('react-datepicker').then(module => {
    // @ts-ignore
    import('react-datepicker/dist/react-datepicker.css');
    return { default: module.default };
  })
);
